import { useCallback, useState } from 'react';
var useToggle = function (initialState) {
    if (initialState === void 0) { initialState = false; }
    var _a = useState(Boolean(initialState)), value = _a[0], setValue = _a[1];
    var enable = useCallback(function () { return setValue(true); }, [setValue]);
    var disable = useCallback(function () { return setValue(false); }, [setValue]);
    var toggle = useCallback(function () { return setValue(function (currentValue) { return !currentValue; }); }, [setValue]);
    return [value, enable, disable, toggle];
};
export default useToggle;
//# sourceMappingURL=useToggle.js.map